<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/qunlong/first/inspection/pageWoList" getKey="rows" :pageSizes="pageSizes" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :max="1" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('moju')">
            <yi_data_select :max="1" :type="'mould'" :ids.sync="yt.conditions.mouldIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpin')">
            <yi_data_select :max="1" :type="'material2'" :ids.sync="yt.conditions.materialIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, beforeReq, afterReq)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ statusList: ['2', '3', '4'], orderBy: 'priority asc' }, beforeReq, afterReq)">
              {{ $t("chongzhi") }}
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <template #buttonsL> </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope"> </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
// import work_bom from '@@/pages/web/order_management/erp/work_bom'
export default {
  name: "web_screen_printing_management_work_order_execution_batch_transfer",
  components: {
    // work_bom
  },
  data() {
    return {
      columns: [
        {
          label: "dingdanfenluID",
          prop: "plan.orderEntryId",
        },
        {
          label: "shebeimingcheng",
          prop: "equipment.name",
        },
        {
          label: "mujumingcheng",
          prop: "mould.name",
        },
        {
          label: "huohao",
          prop: "plan.articleNumber",
        },
        {
          label: "wuliaomingcheng",
          prop: "material.name",
        },
        {
          label: "dingdanzhongliang(KG)",
          prop: "weight",
        },
        {
          label: "danzhong(G)",
          prop: "singleWeight",
        },
        {
          label: "shijimoqiangshu",
          prop: "actualCavity",
        },
        {
          label: "biaozhun/shijizhouqi(miao)",
          prop: "standardCycle_actualCycle",
        },
        {
          label: "beizhu",
          prop: "remark",
        },
        {
          label: "gongdanpaixu",
          prop: "priority",
        },
        {
          label: "gongdanzhuangtai",
          type: "tag",
          prop: "status",
          width: 130,
          tags: {
            1: {
              color: "#419FFF",
              text: this.$t("xinjian"),
            },
            2: {
              color: "#419FFF",
              text: this.$t("fafang"),
            },
            3: {
              color: "#67C23A",
              text: this.$t("shengchanzhong"),
            },
            4: {
              color: "#F56C6C",
              text: this.$t("zanting"),
            },
            5: {
              color: "#67C23A",
              text: this.$t("shougongxuwangong"),
            },
            6: {
              color: "#67C23A",
              text: this.$t("wangong"),
            },
            7: {
              color: "#909399",
              text: this.$t("guanbi"),
            },
            8: {
              color: "#E6A23C",
              text: this.$t("yidiaobo"),
            },
          },
        },
      ],
      selectIds: [],
      pageSizes: [20, 50, 100],
    };
  },

  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = "/web/production/wo/listByIds";
      this.yt.SELECT_RESULT_KEY = "data";
      this.yt.SELECT_ID = "id";
      this.yt.SELECT_TITLE = "no";

      this.yt.pageSize = 20;
      this.yt.conditions = {
        statusList: ["2", "3", "4"],
        orderBy: "priority asc",
      };
      this.yt.get(1, this.beforeReq, this.afterReq);
    }, 300);
  },
  watch: {},
  methods: {
    beforeReq(params) {
      if (params.equipmentIdList == null || params.equipmentIdList.length === 0) {
        params.equipmentIdList = [-1];
      }
      return params;
    },
    afterReq(result) {
      if (result.data.rows.length > 0) {
        for (let i = 0; i < result.data.rows.length; i++) {
          let row = result.data.rows[i];
          row.standardCycle_actualCycle = (row.standardCycle == null ? "-" : row.standardCycle) + "/" + (row.actualCycle == null ? "-" : row.actualCycle);
        }
      }
      return result;
    },
  },
};
</script>
